<script setup lang="ts">
import { tv } from "tailwind-variants";

const variants = tv({
  slots: {
    text: "p-0.5 text-2xl lg:p-1 lg:text-4xl",
    icon: "",
  },
  variants: {
    theme: {
      "green-seagreen": {
        text: "text-seagreen-5",
        icon: "fill-seagreen-pop",
      },
      "dark-red-pink": {
        text: "text-coral-5",
        icon: "fill-coral-pop",
      },
      "blue-pink": {
        text: "text-coral-5",
        icon: "fill-coral-pop",
      },
      "green-red": {
        text: "text-green-5",
        icon: "fill-green-pop",
      },
    },
  },
});

const packet = inject(keys.currentPacket);

const classes = computed(() => variants({ theme: unref(packet)?.theme }));

const quote = computed(() => unref(packet)?.quote);
</script>

<template>
  <section v-if="quote" class="mb-28 bg-inherit py-l lg:py-xl">
    <div class="mx-auto flex w-[54.5rem] max-w-[85vw] gap-9">
      <SvgQuotes class="hidden min-w-24 xs:block" :class="classes.icon()" />
      <div class="xs:mt-7" :class="classes.text()">
        <SvgQuotes class="float-left -my-7 mr-3 w-11 xs:hidden" :class="classes.icon()" />
        <blockquote class="font-headline" v-html="quote.text" />

        <div
          v-if="quote.author"
          class="mt-6 flex flex-col"
        >
          <strong class="text-base font-semibold leading-6 lg:text-lg">{{ quote.author.name }}{{ quote.author.role ? ', ' : '' }}</strong>
          <span
            v-if="quote.author.role"
            class="text-base font-normal leading-6"
            v-text="quote.author.role"
          />
        </div>
      </div>
    </div>
  </section>
</template>
